var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('details-box-heading',{staticClass:"mb-1",attrs:{"label":"ODA verklaring"}}),_c('div',{staticClass:"box-content mb-2"},[_c('span',{class:['tag', _vm.odaStatus.tagClass],staticStyle:{"height":"1.3em"}},[_vm._v(_vm._s(_vm.odaStatus.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }